import { Reveal } from "@/components/Reveal";

const IMAGES = [
  {
    src: "/gallery/event-popup-golf.jpg",
    alt: "Shaken Society pop-up bar with the Golf Tees & Beers tip sign at a golf outing",
    caption: "Golf outing pop-up bar",
    cls: "md:col-span-2 md:row-span-2",
    real: true,
    test: "gallery-img-popup",
  },
  {
    src: "/gallery/event-cocktail.jpg",
    alt: "Signature cocktail served in a branded Shaken Society cup",
    caption: "Signature pour",
    cls: "md:row-span-2",
    captionTop: true,
    real: true,
    test: "gallery-img-cocktail",
  },
  {
    src: "/gallery/event-bartender.jpg",
    alt: "Bartender crafting drinks behind the bar",
    caption: "Behind the bar",
    cls: "md:row-span-2",
    real: true,
    test: "gallery-img-bartender",
  },
  {
    src: "/gallery/event-poolside.jpg",
    alt: "Poolside signature cocktails with orchid and fruit garnishes",
    caption: "Poolside refreshers",
    cls: "md:col-span-2 md:row-span-2",
    imgCls: "object-[50%_58%]",
    captionTop: true,
    real: true,
    test: "gallery-img-poolside",
  },
  {
    src: "https://images.unsplash.com/photo-1580657274234-7339717f4541?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxjaGFtcGFnbmUlMjB0b2FzdCUyMHBhcnR5fGVufDB8fHx8MTc5MDcxMjc0MHww&ixlib=rb-4.1.0&q=85",
    alt: "Guests toasting with champagne",
    cls: "md:col-span-2 md:row-span-2",
    real: false,
    test: "gallery-img-toast",
  },
  {
    src: "https://images.pexels.com/photos/8920034/pexels-photo-8920034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Styled bar setup at an event",
    cls: "md:col-span-4",
    real: false,
    test: "gallery-img-setup",
  },
  {
    src: "/gallery/event-mojitos.jpg",
    alt: "Crafted mojitos with lime and mint beside rum and liqueur bottles",
    caption: "Crafted mojitos",
    cls: "md:col-span-2",
    real: false,
    test: "gallery-img-mojitos",
  },
  {
    src: "/gallery/event-spritz-bubbles.jpg",
    alt: "Aperol spritz in a branded cup beside champagne and prosecco bottles",
    caption: "Bubbles & spritzes",
    cls: "md:col-span-2",
    captionTop: true,
    real: true,
    test: "gallery-img-spritz-bubbles",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-cream px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <span className="eyebrow text-espresso/50">Gallery</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl">
                Recent <em className="italic text-rose">shakes</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-espresso/65 sm:text-base">
              Real setups from real Shaken Society events — pop-ups, signature pours
              and nights behind the bar.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid auto-rows-[200px] grid-cols-2 gap-4 sm:auto-rows-[240px] md:grid-cols-4">
          {IMAGES.map((img, i) => (
            <Reveal key={img.test} delay={(i % 3) * 0.1} className={`${img.cls} h-full`}>
              <div
                data-testid={img.test}
                className="group relative h-full w-full overflow-hidden rounded-3xl"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110 ${img.imgCls || ""}`}
                />
                <div className="absolute inset-0 bg-espresso-deep/0 transition-colors duration-500 group-hover:bg-espresso-deep/25" />
                {img.real && (
                  <span
                    className={`absolute left-3 rounded-full bg-espresso-deep/70 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-cream backdrop-blur-md ${img.captionTop ? "top-3" : "bottom-3"}`}
                    data-testid={`${img.test}-caption`}
                  >
                    {img.caption}
                  </span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}